// extracted by mini-css-extract-plugin
export default {"Container":"ReportedComment_Container__YTeL7"};